const e = {
  name: "CreditCardChip",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M0,33c0,3.9,3.1,7,7,7h26c3.9,0,7-3.1,7-7V7c0-3.9-3.1-7-7-7H7C3.1,0,0,3.1,0,7V33z M7,2h5v11H2V7
			C2,4.2,4.2,2,7,2z M2,26V15h10v11H2z M2,33v-5h17v10H7C4.2,38,2,35.8,2,33z M21,38V28h17v5c0,2.8-2.2,5-5,5H21z M26,26H14V2h12V26
			z M28,15h10v11H28V15z M28,13V2h5c2.8,0,5,2.2,5,5v6H28z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as CreditCardChip
};
